import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69c2ad1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "reader",
  width: "600px"
}, null, -1))
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_loading_skeleton = _resolveComponent("loading-skeleton")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        title: $setup.t('coralCertificates'),
        titleOnly: true,
        style: {"padding-right":"16px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, {
            slot: "end",
            color: "success",
            size: "large",
            icon: $setup.shieldCheckmark
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_fab, {
            vertical: "bottom",
            horizontal: "end",
            slot: "fixed"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_fab_button, {
                color: $setup.isScanning ? 'danger' : 'primary',
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleScan()))
              }, {
                default: _withCtx(() => [
                  ($setup.isScanning)
                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 0,
                        icon: $setup.close
                      }, null, 8, ["icon"]))
                    : (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 1,
                        icon: $setup.scan
                      }, null, 8, ["icon"]))
                ]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _hoisted_1,
              ($setup.loading)
                ? (_openBlock(), _createBlock(_component_loading_skeleton, { key: 0 }))
                : (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                    default: _withCtx(() => [
                      ($setup.certificates.length == 0)
                        ? (_openBlock(), _createBlock(_component_ion_card, {
                            key: 0,
                            class: "primary-border ion-text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('purchaseGetFirstCert')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_content, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", null, [
                                    _createVNode(_component_ion_button, { "router-link": "/products" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.t('CartPage.shopNow')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.certificates, (cert) => {
                        return (_openBlock(), _createBlock(_component_ion_card, {
                          key: cert.id,
                          button: "",
                          "router-link": `/certificates/${cert.id}`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_col, { size: "5" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      class: "cert-img",
                                      src: $setup.addResizeUrlParams(cert.certImgLink)
                                    }, null, 8, _hoisted_2)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_col, { size: "7" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_card_header, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_card_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(cert.certificateNumber), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_ion_card_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(cert.acquisitionDate), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_card_content, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", null, _toDisplayString(cert.coralSpecies), 1),
                                        _createElementVNode("p", null, _toDisplayString(cert.coralId), 1),
                                        _createVNode(_component_ion_button, {
                                          class: "detail-btn",
                                          size: "small",
                                          fill: "clear"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('details')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["router-link"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}